import { render, staticRenderFns } from "./TestimoniesCarousel.vue?vue&type=template&id=0ebc0fbf&"
import script from "./TestimoniesCarousel.vue?vue&type=script&lang=js&"
export * from "./TestimoniesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TestimoniesCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports